function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.391 2.087a7.304 7.304 0 105.07 12.563 1.03 1.03 0 01.19-.19A7.304 7.304 0 009.39 2.087zm7.338 13.166a9.352 9.352 0 002.053-5.862 9.391 9.391 0 10-9.39 9.392 9.351 9.351 0 005.861-2.054l6.966 6.965a1.043 1.043 0 001.475-1.475l-6.965-6.966z",
    fill: props.fill
  }));
};
export default SvgSearch;